import React, { useEffect, useState } from "react";
import PageHeader from "../components/PageHeader";
import dots from "../assets/dots.svg";
import Dropdown from "react-bootstrap/Dropdown";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import { activateRole, deleteRole, roleList } from "../action/role";
import CommonModal from "../components/CommonModal";
import { Spinner } from "react-bootstrap";
import Paginate from "../components/pagination";
import ActivateModal from "../components/ActivateModel";
import EditRoleDetailsModal from "../components/EditRoleDetailsModal";
import CreateRoleDetailsModal from "../components/CreateRoleDetailsModal";
import { toast } from "react-toastify";

const DeactivateModal = ({ title, show, onClose, onDelete, deleting }) => {
  return (
    <CommonModal show={show} onClose={onClose}>
      <div className="modal-card-body p-3">
        <div className="modal-card-content">
          <div className="message-title mb-3">Confirm Deactivation</div>
          <div className="message-text mb-3">
            Are you sure you want to deactivate this {title}?
          </div>
        </div>
        <div className="card-footer-box">
          <button onClick={onClose} className="btn-grey ms-auto me-3">
            Close
          </button>
          <button onClick={onDelete} className="btn-black">
            {deleting ? <Spinner size="sm" /> : "Deactivate"}
          </button>
        </div>
      </div>
    </CommonModal>
  );
};

const Role = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const params = useParams();
  const [roles, setRoles] = useState([]);
  const [showDeactivateModal, setShowDeactivateModal] = useState(false);
  const [showActivateModal, setShowActivateModal] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const [showCreateModal, setShowCreateModal] = useState(false);
  const [roleId, setRoleId] = useState("");
  const [deleteLoader, setDeleteLoader] = useState(false);
  const [pagination, setPagination] = useState({
    page: 1,
    limit: 10,
    total: 0,
  });
  const fetchRoles = async () => {
    try {
      const res = await roleList(pagination.page,pagination.limit);
      if (res?.status) {
        setPagination((prev) => ({
          ...prev,
          total: Math.ceil(res.data.total / prev.limit) || 0,
        }));
        setRoles(res.data.list);
      }
    } catch (error) {
      console.log("Error");
    }
  };

  const handleDelete = async () => {
    setDeleteLoader(true);
    try {
      const res = await deleteRole(roleId);
      if (res.status) {
        fetchRoles();
      }
    } catch (e) {
      console.log("Falied to delete", e);
    }
    setDeleteLoader(false);
    setShowDeactivateModal(false);
    setRoleId("");
  };

  const handleActivate = async () => {
    setDeleteLoader(true);
    try {
      const res = await activateRole(roleId);
      if (res.status) {
        fetchRoles();
      }
    } catch (e) {
      console.log("Falied to activate role", e);
    }
    setDeleteLoader(false);
    setShowActivateModal(false);
    setRoleId("");
  };
  const handlePageChange = (page) => {
    const newParams = new URLSearchParams(location.search);
    newParams.set("page", page);
    newParams.set("limit", pagination.limit);

    navigate(`?${newParams.toString()}`, { replace: true });

    setPagination((prev) => ({ ...prev, page: page }));
  };

  const handlePageSizeChange = (limit) => {
    const newParams = new URLSearchParams(location.search);
    newParams.set("page", 1);
    newParams.set("limit", limit);

    navigate(`?${newParams.toString()}`, { replace: true });

    setPagination((prev) => ({ ...prev, limit: limit, page: 1 }));
  };

  useEffect(() => {
    fetchRoles();
  }, [params]);
  return (
    <>
      <PageHeader pageTitle="Role" is_deploy_enable={false}>
        <button 
          className="btn-black"
          onClick={() => setShowCreateModal(true)}
        >
          Create Role
        </button>
      </PageHeader>

      <div className="page-container">
        <div className="role-header mb-4">
          <div className="role-tabs">
            <Link to="/account" className="role-tab">
              Users
            </Link>
            <Link to="/role" className="role-tab active">
              Roles
            </Link>
          </div>
        </div>
        <div className="theme-card p-4">
          <div className="d-flex align-items-center mb-3">
            <div className="card-title pb-3">Roles</div>
            {/* <div className="sel-box ms-auto">
              <select name="selmenu" id="selmenu" className="theme-select">
                <option value="">Filter</option>
                <option value="">Filter Options</option>
              </select>
            </div> */}
          </div>
          <table className="pages-table">
            <thead>
              <tr>
                <th>Role Name</th>
                <th>Status</th>
                <th className="text-end" width="10%">
                  Actions
                </th>
              </tr>
            </thead>
            <tbody>
              {roles &&
                roles.map((r, i) => {
                  return (
                    <tr key={i}>
                      <td key={i}>{r.name}</td>

                      <td>
                        <span
                          className={`status ${
                            r.is_active ? "success" : "danger"
                          }`}
                        >
                          {r.is_active ? "Active" : "Inactive"}
                        </span>
                      </td>
                      <td className="text-end" width="10%">
                        <Dropdown align="end">
                          <Dropdown.Toggle variant="button">
                            <button className="dotbtn">
                              <img src={dots} alt="" />
                            </button>
                          </Dropdown.Toggle>
                          <Dropdown.Menu className="sm">
                            {r.is_active && (
                              <Dropdown.Item
                                as="button"
                                onClick={() => {
                                  setRoleId(r._id);
                                  setShowEditModal(true);
                                }}
                              >
                                Edit
                              </Dropdown.Item>
                            )}
                            {!r.is_active ? (
                              <Dropdown.Item
                                as={Link}
                                to="#"
                                className="text-success"
                                onClick={() => {
                                  setRoleId(r._id);
                                  setShowActivateModal(true);
                                }}
                              >
                                Activate
                              </Dropdown.Item>
                            ) : (
                              <Dropdown.Item
                                as={Link}
                                to="#"
                                className="text-danger"
                                onClick={(e) => {
                                  e.preventDefault();
                                  if (r.user_count > 0) {
                                    toast.error(
                                      "Please deactivate users first to deactivate this role."
                                    );
                                    return;
                                  }
                                  setRoleId(r._id);
                                  setShowDeactivateModal(true);
                                }}
                              >
                                Deactivate
                              </Dropdown.Item>
                            )}
                          </Dropdown.Menu>
                        </Dropdown>
                      </td>
                    </tr>
                  );
                })}
            </tbody>
          </table>
          <div className="px-3 pb-3">
              {Boolean(pagination?.total) && (
                <Paginate
                  currentPage={pagination?.page}
                  totalPages={pagination?.total}
                  onPageChange={handlePageChange}
                  pageSize={pagination.limit}
                  onPageSizeChange={handlePageSizeChange}
                />
              )}
            </div>
        </div>
      </div>
      <DeactivateModal
        title="Role"
        show={showDeactivateModal}
        onClose={() => setShowDeactivateModal(false)}
        onDelete={handleDelete}
        deleting={deleteLoader}
      />
      <ActivateModal
        title="Role"
        show={showActivateModal}
        onClose={() => setShowActivateModal(false)}
        onDelete={handleActivate}
        deleting={deleteLoader}
      />
      <EditRoleDetailsModal
        show={showEditModal}
        onClose={() => {
          setShowEditModal(false);
          setRoleId("");
        }}
        roleId={roleId}
        onSuccess={fetchRoles}
      />
      <CreateRoleDetailsModal
        show={showCreateModal}
        onClose={() => setShowCreateModal(false)}
        onSuccess={fetchRoles}
      />
    </>
  );
};

export default Role;
